/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Hanly API v2
 * OpenAPI spec version: 0.0.1
 */

import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { ErrorType } from '../../custom-client';

import { customInstance } from '../../custom-client';
import type { DetailError, StandardizedError } from '../hanlyAPIV2.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getSignoutUrl = () => {
  return '/api/v2/accounts/signout';
};

/**
 * 明示的なサインアウトを監査ログに記録する。JWT はステートレスなのでトークンは失効しない。画面はトークンを破棄する前に呼ぶ。
 * @summary サインアウト
 */
export const signout = async (options?: Parameters<typeof customInstance>[1]): Promise<null> => {
  return customInstance<null>(getSignoutUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getSignoutMutationKey = () => ['signout'] as const;

export const getSignoutMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof signout>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof signout>>, TError, void, TContext> => {
  const mutationKey = getSignoutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof signout>>, void> = () => {
    return signout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignoutMutationResult = NonNullable<Awaited<ReturnType<typeof signout>>>;

export type SignoutMutationError = ErrorType<StandardizedError | DetailError>;

/**
 * @summary サインアウト
 */
export const useSignout = <TError = ErrorType<StandardizedError | DetailError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof signout>>, TError, void, TContext>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof signout>>, TError, void, TContext> => {
  return useMutation(getSignoutMutationOptions(options), queryClient);
};
